import { StaticPropertyKey } from '@bvi/api-interfaces/entity/case-property';
import { IAutocompleteValue } from '@bvi/common-components';

import { OnOptionsLoad } from './types';

export const dedupeJobTitleValues = (
  values: Array<{ id: number; name: string }>,
): Array<{ id: number; name: string }> =>
  values.filter(
    (item, index, self) =>
      index === self.findIndex((entry) => entry.id === item.id),
  );

export async function fetchAllJobTitles(
  onOptionsLoad: OnOptionsLoad,
): Promise<Array<IAutocompleteValue>> {
  let allJobTitles: Array<IAutocompleteValue> = [];
  let currentPage = 1;
  let hasMorePages = true;

  while (hasMorePages) {
    const response = await onOptionsLoad(StaticPropertyKey.JOB_TITLE, {
      page: currentPage,
      search: '',
    });

    const pageData = response?.data?.payload?.data ?? [];
    allJobTitles = [...allJobTitles, ...pageData];

    const meta = response?.data?.payload?.meta;
    if (meta?.totalPages) {
      hasMorePages = currentPage < meta.totalPages;
      currentPage++;
    } else {
      hasMorePages = false;
    }
  }

  return allJobTitles;
}

export const mapJobTitleValues = (
  jobTitles: Array<IAutocompleteValue>,
): Array<{ id: number; name: string }> =>
  jobTitles.map((jobTitle) => ({
    id: typeof jobTitle.id === 'number' ? jobTitle.id : Number(jobTitle.id),
    name: jobTitle.name ?? '',
  }));
